let inputCounter = 1;

document.addEventListener("DOMContentLoaded", function () {
    const radios = document.querySelectorAll('div.hidden input[type="radio"]');
    for (let radio of radios) {
        if (radio.checked) {
            radio.checked = false;
        }
    }
    let modelCheckbox = document.getElementsByClassName('use_models')[0];
    let modelInputWrapper = document.getElementById('model-wrapper');
    let submitBtn = document.getElementById('submitOrder');

    if (modelCheckbox && modelInputWrapper) {
        modelCheckbox.addEventListener('click', function (event) {
            if (event.target.checked) {
                modelInputWrapper.classList.remove('hidden');
            } else {
                modelInputWrapper.classList.add('hidden');
            }
        });

        if (submitBtn) {
            submitBtn.addEventListener('click', function (event) {
                if(document.checkoutForm.checkValidity()) {
                    event.preventDefault();
                    assembleModelInputs();
                    // Check if the correct associated Product Country has been selected
                    window.checkCountryAndCancelledByInsurer();
                }
            });
        }

        let buttons = modelInputWrapper.getElementsByClassName('icon');
        if (buttons.length > 0) {
            Array.from(buttons).forEach(button => {
                button.addEventListener('click', function (event) {
                    event.preventDefault();
                    if(button.classList.contains('icon-plus')) {
                        addModelInputField();
                    } else if (button.classList.contains('icon-minus')) {
                        removeModelInputField(event);
                    }
                });
            });
        }

        let inputs = modelInputWrapper.getElementsByTagName('input');
        if (inputs) {
            Array.from(inputs).forEach(input => {
                input.addEventListener('input', handleModelInputCount);
            });
        }

        if (modelCheckbox.checked) {
            modelInputWrapper.classList.remove('hidden');
        }

        if (models && models !== '') {
            addOldInputFields(models.split(','));
            handleModelInputCount();
        } else if (oldModelInputs && oldModelInputs !== '') {
            addOldInputFields(oldModelInputs.split(','));
            handleModelInputCount();
        }
    } else {
        if (submitBtn) {
            submitBtn.addEventListener('click', function (event) {
                if(document.checkoutForm.checkValidity()) {
                    event.preventDefault();
                    // Check if the correct associated Product Country has been selected and
                    // Check if insurance has not been cancelled by insurer during last 5 years else cancel submit
                    window.checkCountryAndCancelledByInsurer();
                }
            });
        }
    }
});

window.addOldInputFields = function (inputs) {
    let splittedModels = Array.isArray(inputs) ? inputs : inputs.split(',');
    let modelCount = splittedModels.length;

    for (let i = 1; i <= modelCount; i++) {
        i !== 1 ? addModelInputField() : null;
        let input = document.getElementById(`modelInput[${i}]`);
        if (input) {
            input.value = splittedModels[i - 1];
        }
    }
};

window.assembleModelInputs = function () {
    let wrapper = document.getElementById('model-inputs-wrapper');
    if (wrapper) {
        let inputs = wrapper.getElementsByTagName('input');
        let inputsValue = '';
        if (inputs && inputs.length > 0) {
            Array.from(inputs).forEach((input, index) => {
                inputsValue += index === 0 ? input.value : ', ' + input.value;
                input.addEventListener('input', handleModelInputCount);
            });

            let hiddenModelInputField = document.getElementById('hidden-model-input');
            hiddenModelInputField.setAttribute('value', inputsValue);
            wrapper.appendChild(hiddenModelInputField);
        }
    }
};

window.addModelInputField = function () {
    let inputContainer = document.getElementById('model-inputs-wrapper');
    if (inputContainer) {
        let wrapper = document.createElement('div');
        wrapper.classList.add('input-wrapper', 'flex-container');
        let input = createInputField();

        let fieldControls = document.createElement('div');
        fieldControls.classList.add('field-controls', 'inline-block');

        let minusButton = createButton('minus');
        fieldControls.appendChild(minusButton);

        let plusButton = createButton('plus');
        fieldControls.appendChild(plusButton);

        wrapper.appendChild(input);
        wrapper.appendChild(fieldControls);
        inputContainer.appendChild(wrapper);
    }
};

window.handleModelInputCount = function (event = null) {
    let count = countModelInputFieldCharacters();
    if (count >= maxModelInputCharacterCount + 1) {
        if (event) {
            event.target.value = event.target.value.slice(0, -(count - maxModelInputCharacterCount));
        }
        count = maxModelInputCharacterCount;
    }
    updateModelInputCounter(count);
};

window.countModelInputFieldCharacters = function () {
    let inputWrapper = document.getElementById('model-inputs-wrapper');
    if (inputWrapper) {
        let inputs = inputWrapper.getElementsByTagName('input');
        if (inputs) {
            let charCount = 0;
            Array.from(inputs).forEach(input => {
                charCount += input.value.length;
            });
            return charCount;
        }
    }
    return 0;
};

window.updateModelInputCounter = function (charCount) {
    let counter = document.getElementById('model-inputs-character-counter');
    if (counter) {
        counter.innerHTML = `${charCount}/${maxModelInputCharacterCount} ${characterWording}`;
    }
};

window.removeModelInputField = function (event) {
    let wrapper = document.getElementById('model-inputs-wrapper');
    if (wrapper && event.target.parentNode.parentNode && event.target.parentNode.parentNode.classList.contains('input-wrapper')) {
        wrapper.removeChild(event.target.parentNode.parentNode);
    }
    handleModelInputCount();
};

window.createInputField = function () {
    inputCounter += 1;
    let input = document.createElement('input');
    input.setAttribute('placeholder', lang.additional_devices_placeholder);
    input.setAttribute('id', `modelInput[${inputCounter}]`);
    input.setAttribute('name', `modelInput[${inputCounter}]`);
    input.classList.add('form-control');
    input.addEventListener('input', handleModelInputCount);
    return input;
};

window.createButton = function (type) {
    let button = document.createElement('a');
    button.classList.add('icon');
    button.classList.add(`icon-${type}`);
    button.setAttribute('href', '#');
    button.addEventListener('click', function (event) {
        event.preventDefault();
        type === 'minus' ? removeModelInputField(event) : addModelInputField(event);
    });
    return button;
};

window.assembleLicensePlates = function () {
    let licensePlates = document.querySelectorAll('input[name="licencePlateInput[]"]');
    if (licensePlates) {
        let licensePlatesValue = Array.from(licensePlates).map(it => it.value).join(',');

        let hiddenLicensePlateField = document.querySelector('.licencePlate');
        if (hiddenLicensePlateField) {
            hiddenLicensePlateField.setAttribute('value', licensePlatesValue);
        }
    }
};
